// BidHistory.js

import React from "react";
import { Link } from 'react-router-dom';
import { Compoicon } from "../constant/constant";

const All_bids = () => {
    
  return (
    <div className="all_bids">
           <Link to={'/my-bid'} className="footer-icon"><div className="child_comp">Bid History  <Compoicon/></div></Link>
           <Link to={'/fund_histry/ALL_FUND_HISTROY'} className="footer-icon"><div className="child_comp">Fund Request History  <Compoicon/></div></Link>
           <Link to={'/fund_histry/APPROVED_DEPOSITE'}  className="footer-icon"> <div className="child_comp">Approved Credit History  <Compoicon/></div></Link>
           <Link to={'/fund_histry/APPROVED_WITHDRAWAL'} className="footer-icon"> <div className="child_comp">Approved Debit History  <Compoicon/></div></Link>
   </div>
    
  );
};



export default All_bids;
